/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Template = require("personalization-templates/personalizationWidget.tmpl");
    var Bubble = require("ui/bubble/Bubble");
    var _ = require("underscore");
    var CONST = require("const");
    var KpContent = require("ui.components/kpContent/kpContent");

    var PersonalizationWidgetView;
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        PersonalizationWidgetView = Marionette.ItemView.extend({
            template: Template,
            withUIComponents: true,
            events: {
                click: "_onClick",
                mouseover: "_onHover",
                mouseleave: "_onMouseLeave"
            },
            ui: {
                personalizationIcon: ".personalizationIcon"
            },
            modelEvents: {
                "change:featuresByRoutCount": "_onFeaturesByRoutCountChange"
            },
            bubbleComponentId: "PersonalizationWidgetBubble",

            kpContentComponentId: "PersonalizationWidgetKpContent",

            onRender: function () {
                var featuresByRoutCount = this.model.get("featuresByRoutCount");
                this._toggleWidgetState(featuresByRoutCount);
            },
            _onFeaturesByRoutCountChange: function (model, featuresByRoutCount) {
                this._toggleWidgetState(featuresByRoutCount);
            },
            _toggleWidgetState: function (featuresByRoutCount) {
                this.featuresByRoutCount = featuresByRoutCount;
                if (this.featuresByRoutCount > 0) {
                    this.ui.personalizationIcon.removeClass("personalizationIcon-disabled");
                }
                else {
                    this.ui.personalizationIcon.addClass("personalizationIcon-disabled");
                }
            },
            _onClick: function () {
                this.trigger("personalizationWidgetView:toggleState", {featuresByRoutCount: this.featuresByRoutCount});
            },
            _onHover: function () {
                this._createAndRenderBubble();
            },
            _getBubbleText: function () {
                var text;
                if (this.featuresByRoutCount > 0) {
                    text = LE.translator.translate({
                        key: "LEPersonalization.widget.itemsToPersonalize",
                        args: [this.featuresByRoutCount]
                    });
                }
                else {
                    text = LE.translator.translate("LEPersonalization.widget.noItemsToPersonalize");
                }
                return text;
            },
            _createAndRenderBubble: function () {
                this._closeBubble(true);

                var bubbleOptions = this._getBubbleOptions();
                this.uiComponents.host$.createAndRender(this.bubbleComponentId, {
                    type: Bubble,
                    options: bubbleOptions
                });
            },
            _getBubbleOptions: function () {
                this._createAndRenderKpContent();
                var text = this._getBubbleText();
                var bubbleOptions = {
                    targetControl: this.ui.personalizationIcon,
                    contentView: this.uiComponents[this.kpContentComponentId],
                    showCloseButton: false

                };
                return bubbleOptions;
            },
            _onMouseLeave: function () {
                this._closeBubble();
            },
            _createAndRenderKpContent: function () {
                this.uiComponents.host$.createAndRender(this.kpContentComponentId, {
                    type: KpContent,
                    options: {
                        content: this._getBubbleText(),
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEPersonalization.webAgent.ACD.title.learnMore"),
                        kpID: "advanced-configuration-overview"
                    },
                    events: {
                        "click": "_closeBubble"
                    }
                });
            },
            _closeBubble: function (forceClose) {
                if (this.uiComponents && this.uiComponents[this.bubbleComponentId]) {
                    this.uiComponents[this.bubbleComponentId].close(forceClose);
                }
            }

        });
    });
    return PersonalizationWidgetView;

});

